export default __webpack_public_path__ + "static/media/more-active.3c34d952.svg";